import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  meetings: [],
  isLoading: false,
  error: null,
  lastFetch: null,
};

const meetingsSlice = createSlice({
  name: 'meetings',
  initialState,
  reducers: {
    setMeetings: (state, action) => {
      state.meetings = action.payload;
      state.lastFetch = new Date().toISOString();
      state.isLoading = false;
      state.error = null;
    },
    addMeeting: (state, action) => {
      state.meetings.unshift(action.payload); // newest first
    },
    updateMeeting: (state, action) => {
      const idx = state.meetings.findIndex(m => m.id === action.payload.id);
      if (idx !== -1) {
        state.meetings[idx] = { ...state.meetings[idx], ...action.payload };
      }
    },
    removeMeeting: (state, action) => {
      state.meetings = state.meetings.filter(m => m.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    appendMeetings: (state, action) => {
      state.meetings = [...state.meetings, ...action.payload];
    },
  },
});

export const {
  setMeetings,
  addMeeting,
  updateMeeting,
  removeMeeting,
  setLoading,
  setError,
  appendMeetings,
} = meetingsSlice.actions;

export const selectAllMeetings = (state) => state.meetings.meetings;
export const selectMeetingsLoading = (state) => state.meetings.isLoading;
export const selectMeetingsError = (state) => state.meetings.error;

export default meetingsSlice.reducer; 